import { ExternalLink as ExternalLinkIcon } from "lucide-react"
import { cn } from "@/lib/utils"
import type { AnchorHTMLAttributes, ReactNode } from "react"

interface ExternalLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode
  showIcon?: boolean
}

export function ExternalLink({
  className,
  children,
  showIcon = true,
  ...rest
}: ExternalLinkProps) {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "text-foreground underline underline-offset-[3px] inline-flex items-center gap-1.5",
        className,
      )}
      {...rest}
    >
      {children}
      {showIcon && (
        <ExternalLinkIcon className="h-3.5 w-3.5 stroke-[1.5] text-muted-foreground" />
      )}
    </a>
  )
}
